export default [
    {
        path: '/ssddt',
        component: () => import('@/views/homePage/menu/suoshuidan_dating/index.vue'),
    },
    {
        path: '/excel',
        component: () => import('@/views/homePage/menu/excel/index.vue'),
    },
    {
        path: '/suoshuiruanjian',
        component: () => import('@/views/homePage/menu/suoshuiruanjian/index.vue'),
    },
    {
        path: '/ssdgw',
        component: () => import('@/views/homePage/menu/ssdgw'),
    },
    {
        path: '/sdssxb',
        component: () => import('@/views/homePage/menu/sdssxb/index.vue'),
    },
    {
        path: '/sttzzbfzx',
        component: () => import('@/views/homePage/menu/sttzzbfzx'),
    },
    {
        path: '/hxwysz',
        component: () => import('@/views/homePage/menu/hxwysz/index.vue'),
    },
    {
        path: '/hxwysz/list',
        component: () => import('@/views/homePage/menu/hxwysz/list.vue'),
    },
    {
        path: '/hxwysz/detail/:id',
        component: () => import('@/views/homePage/menu/hxwysz/detail.vue'),
    },
    {
        path: '/hxwysz/result',
        component: () => import('@/views/homePage/menu/hxwysz/result.vue'),
    },
    {
        path: '/hxwysz/submit',
        component: () => import('@/views/homePage/menu/hxwysz/submit.vue'),
    },
]
